import { gql } from '@apollo/client';

// export const FETCH_SERIES_BY_CATEGORY_ID = gql`
//     query FetchSeriesByCategoryId ($category_id:String!){
//         fetchSeriesByCategoryId(category_id: $category_id) {
//             data {
//                 series {
//                     folder_id
//                     id
//                     title
//                     order
//                 }
//             }
//             error {
//                 message
//             }
//         }
//     }

// `;

export const FETCH_SERIES_BY_CATEGORY_ID = gql`
   query FetchSeriesByCategoryId($category_id:UUID!) {
    fetchSeriesByCategoryId(category_id: $category_id) {
        data {
            series {
                category_id
                created_at
                folder_id
                id
                series_order
                title
                updated_at
            }
        }
        error {
            code
            field
            message
        }
    }
}
`;


